// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FlagFilledSvg from "@fishx/icons-svg/es/asn/FlagFilled";
import FishxIcon from '../components/FishxIcon';

var FlagFilled = function FlagFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FlagFilledSvg
  }));
};

FlagFilled.displayName = 'FlagFilled';
export default React.forwardRef(FlagFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FlagFilled.js
// module id = 2790
// module chunks = 0